/**
 * Rögzítési napló: a háttérmérés és az automatikus szünet diagnosztikája.
 *
 * MIÉRT VAN? A 2026-10-18-i iPhone-os esetben (2f556717) a nyomvonal mozgás
 * közben, az app háttérbe kerülésekor ért véget, és utólag nem volt kiolvasható,
 * mi történt: a láthatóság-idővonal csak a JS memóriájában élt, és a WebView
 * újratöltésével elveszett. Ez a napló a mentett rögzítéssel EGYÜTT tárolódik
 * (`PersistedRun.trace`), így túléli az újratöltést, és a feltöltéssel a
 * `private/track` dokumentumba kerül (csak a tulajdonos és az admin olvassa).
 *
 * ⚠️ NEM TARTALMAZ HELYADATOT. Csak időbélyeget, számlálót és állapotjelzőt —
 * koordináta soha.
 */

/** Az események fajtái. Új fajtához a szerver `parseTrace`-ét is bővíteni kell. */
export type TraceKind =
  /** Előtér/háttér váltás (`v`: `f` előtér, `b` háttér). */
  | 'vis'
  /** Natív sor kiürítése: hány pont jött, mennyit puffereltünk. */
  | 'drain'
  /** Automatikus szünet be/ki, és MI döntött (`src`: tick vagy minta). */
  | 'ap'
  /** Háttérben végzett időzített ellenőrzések összegzése (él-e a JS háttérben). */
  | 'bgpoll'
  /** Visszaállítás: melyik ágon és milyen bizonyítékkal döntöttünk. */
  | 'restore'
  /** Natív állapot-pillanatkép (`updating`, `lastFixAgeMs`, `resumerActive`…). */
  | 'diag'
  /** A lemezes sorból utólag beolvasott pontok visszaállításkor. */
  | 'catchup';

export type TraceValue = number | boolean | string;

export interface TraceEvent {
  /** Epoch ms. */
  t: number;
  k: TraceKind;
  /** Láthatóság az esemény pillanatában: `f` előtér, `b` háttér. */
  v?: 'f' | 'b';
  d?: Record<string, TraceValue>;
}

/** Egy aktivitás naplójának plafonja — a mentett dokumentum ne hízzon el. */
export const MAX_TRACE_EVENTS = 300;

/** Hozzáfűz egy eseményt; a plafon fölött a legrégebbi esik ki. */
export function appendTrace(list: TraceEvent[], event: TraceEvent): void {
  list.push(event);
  if (list.length > MAX_TRACE_EVENTS) list.splice(0, list.length - MAX_TRACE_EVENTS);
}
